import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsEditorComponent } from './details-editor/details-editor.component';
import { OutletsComponent } from './outlets.component';
import { UIModule } from '../../ui/ui.module';
import { SharedModule } from '../../../shared/shared.module';
import { JvUiModule } from '../../../../../projects/jv-ui/src/lib/jv-ui.module';
import { DepositsEditorComponent } from './deposits-editor/deposits-editor.component';
import { LookupComponent } from './lookup/lookup.component';

@NgModule({
  imports: [
    CommonModule,
    UIModule,
    SharedModule,
    JvUiModule
  ],

  declarations: [
    OutletsComponent,
    DetailsEditorComponent,
    DepositsEditorComponent,
    LookupComponent,
  ],

  entryComponents: [
    DetailsEditorComponent,
    DepositsEditorComponent,
    LookupComponent
  ]
})
export class OutletsModule { }
